import { FetchResult } from '@apollo/client';
import { useSubmit } from 'formik-apollo';
import React from 'react';
import { useHistory } from 'react-router-dom';
import AppToaster from '../../../AppToaster';
import {
  NewPasswordWithCodeInput,
  UpdateForgottenPasswordMutation,
  useUpdateForgottenPasswordMutation,
} from '../../../generated/graphql';
import { ResetPasswordStatus } from '../../../helpers/constants';
import { getLaravelValidationErrors } from '../../../helpers/graphql';
import useQueryParams from '../../../hooks/useQueryParams';
import ResetForm from '../components/ResetForm';

const ResetPage = () => {
  const history = useHistory();
  const queryParams = useQueryParams();
  const [reset] = useUpdateForgottenPasswordMutation();

  const handleSubmit = useSubmit<NewPasswordWithCodeInput, FetchResult<UpdateForgottenPasswordMutation>>({
    mutate: (values) =>
      reset({
        variables: {
          input: values,
        },
      }),
    onCompleted: ({ data }) => {
      if (data?.updateForgottenPassword?.status === ResetPasswordStatus.Success) {
        AppToaster.success('Passwort wurde festgelegt!');
        history.push('/auth/login');
      }
    },
    getErrors: getLaravelValidationErrors,
  });

  return (
    <div style={styles.container}>
      <ResetForm onSubmit={handleSubmit} email={queryParams.get('email')} token={queryParams.get('token')} />
    </div>
  );
};

export default ResetPage;

const styles = {
  container: {
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
